class MatchedShadeFinder extends HHBaseElement {
  constructor() {
    super()

    this._handleClosed = this._handleClosed.bind(this)
    this._handleAddToBag = this._handleAddToBag.bind(this)
    this._handleLoaded = this._handleLoaded.bind(this)
    this._handleInslidePanelOpen = this._handleInslidePanelOpen.bind(this)
    this._handleInslidePanelClose = this._handleInslidePanelClose.bind(this)
    this.applyLookFromURL = this.applyLookFromURL.bind(this)
    this.show = this.show.bind(this)
    this.close = this.close.bind(this)

    this._initScript()
  }

  get apiKey() {
    return this.getAttribute('api-key')
  }

  get widgetId() {
    return this.getAttribute('widget-id')
  }

  get language() {
    return this.getAttribute('language')
  }

  get enableKissDetection() {
    return this.hasAttribute('enable-kiss-detect')
  }

  get privacyPolicyURL() {
    return this.getAttribute('privacy-policy')
  }

  _initScript() {
    if (document.getElementById('ymk-matched-script')) {
      if (!this.hasAttribute('no-init')) {
        this.show()
      }
    } else {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.id = 'ymk-matched-script'
      window.ymkAsyncInit = () => {
        this._initWidget()
      }
      script.src = `https://plugins-media.makeupar.com/${this.widgetId}/sdk.js?apiKey=${this.apiKey}`
      document.body.appendChild(script)
    }
  }

  _initWidget() {
    YMK.addEventListener('closed', this._handleClosed)
    YMK.addEventListener('addToBag', this._handleAddToBag)
    YMK.addEventListener('loaded', this._handleLoaded)
    YMK.init({
      autoOpen: false,
      language: this.language,
      enableKissDetection: this.enableKissDetection,
      privacyPolicyURL: this.privacyPolicyURL,
    })

    const isInsidePanel = this.closest('slide-panel')
    if (
      !this.hasAttribute('no-init') ||
      (isInsidePanel && isInsidePanel.open)
    ) {
      this.show()
    }
  }

  _handleClosed() {
    this.close()

    this._closeIfInsidePanel()
  }

  _handleLoaded() {
    if (this.isMakeupLook) {
      this.applyLookFromURL()
    }
  }

  applyLookFromURL() {
    const lookGuid = this.makeupLookGuidFromURL
    if (!!lookGuid) {
      YMK.applyMakeupByLook(lookGuid)
    } else {
      this.close()
    }
  }

  async _handleAddToBag(sku) {
    let variantID = 0
    variantID = await this.fetchVariantIdBySKU(sku)

    if (variantID) {
      window.__CART__CONTROLLER__.add([
        {
          id: variantID,
          quantity: 1,
        },
      ])
    } else {
      console.error('Not found product')
    }
  }

  get makeupLookGuidFromURL() {
    const currentHash = window.location.hash
    if (currentHash?.includes('makeup_look')) {
      const lookGuid = currentHash.split('=')[1]
      return lookGuid
    }
  }

  get isMakeupLook() {
    return this.hasAttribute('makeup-look')
  }

  show() {
    if (this.isMakeupLook) {
      YMK.open(true)
    } else {
      YMK.open(true, null, true)
    }
  }

  close() {
    YMK.closeEngine()
  }

  async fetchVariantIdBySKU(sku) {
    const url = `/search?q=${sku}`
    const response = await fetch(url)
    const responseText = await response.text()
    const results = JSON.parse(responseText)
    let variant = null
    if (results.length) {
      variant = results.find((item) => item.sku === sku)
    }
    if (variant) return variant.id
    return 0
  }

  _handleInslidePanelOpen() {
    this.show()
  }

  _handleInslidePanelClose() {
    this.close()
  }

  _closeIfInsidePanel() {
    const isInsidePanel = this.closest('slide-panel')
    if (isInsidePanel) {
      isInsidePanel.open = false
    }
  }

  connectedCallback() {
    const isInsidePanel = this.closest('slide-panel')

    if (isInsidePanel) {
      isInsidePanel.addEventListener(
        'slide-panel-open',
        this._handleInslidePanelOpen
      )
      isInsidePanel.addEventListener(
        'slide-panel-close',
        this._handleInslidePanelClose
      )
    }
  }

  disconnectedCallback() {
    const isInsidePanel = this.closest('slide-panel')
    if (isInsidePanel) {
      isInsidePanel.removeEventListener(
        'slide-panel-open',
        this._handleInslidePanelOpen
      )
      isInsidePanel.removeEventListener(
        'slide-panel-close',
        this._handleInslidePanelClose
      )
    }
  }
}

window.customElements.define('matched-shade-finder', MatchedShadeFinder)
